import {getLanguageStr} from '@/util/language.js';
let message = {};
setTimeout(() => {
	message = {
		// oauth 登录模块
		AUTH_INVALID_USERNAME_OR_PASSWORD: getLanguageStr('user48', '账号或密码错误'),
		solarman_token_invalid: getLanguageStr('phrase639', '你的账号发生了变化，你需要重新登录，具体信息可联系本商家超级管理员'),
		'Invalid token': getLanguageStr('phrase639', '你的账号发生了变化，你需要重新登录，具体信息可联系本商家超级管理员'),

		// 账号
		ACC_SCOPE_NOT_VALID: getLanguageStr('error_code7', '参数不合法'), // 数据权限范围值非法
		ACC_DATA_NOT_VISIBLE: getLanguageStr('error_code7', '参数不合法'), // 数据不可见
		'Cannot convert access token to JSON': getLanguageStr('phrase639', '你的账号发生了变化，你需要重新登录，具体信息可联系本商家超级管理员'),

		sorry_for_server_exception: getLanguageStr('phrase742', '服务器开了个小差，请稍后重试'),
		PARAM_ERROR: getLanguageStr('device236', '参数错误'),
		PARAM_IS_NULL: getLanguageStr('error_code101', '参数不能为空'),
		RESULT_IS_NULL: getLanguageStr('error_code3', '获取不到信息'),
		DB_EXCEPTION: getLanguageStr('phrase742', '服务器开了个小差，请稍后重试'), // 数据库操作异常，请稍后再试
		CAPTCHA_WRONG: getLanguageStr('phrase723', '验证码不正确'),

		CAPTCHA_TOO_FREQUENTLY: getLanguageStr('phrase785', '验证码请求太频繁'),
		AUTH_INVALID_CAPTCHA: getLanguageStr('phrase723', '验证码不正确'),
		CAPTCHA_EXPIRE: getLanguageStr('phrase780', '验证码已过期，请重新发送'),

		EMAIL_ALREADY_REGISTED: getLanguageStr('error_code9', '邮箱已被注册'),
		PHONE_NUMBER_ALREADY_REGISTED: getLanguageStr('phrase16', '该手机号已经被注册'),
		USERNAME_ALREADY_REGISTED: getLanguageStr('phrase704', '用户名已存在'),

		GROUP_MOVE_DOWN_NOT_ALLOWED: getLanguageStr('phrase787', '不允许向下移动组'),
		TOP_GROUP_NOT_ALLOW_DELETE: getLanguageStr('error_code11', '顶级组不允许删除'),
		TOP_GROUP_MUST_BE_UNIQUE: getLanguageStr('error_code12', '顶级组必须唯一'),
		GROUP_LEVEL_EXCEED: getLanguageStr('error_code13', '超出组层级上限（上限为5级）'),
		ACCOUNT_NOT_NULL: getLanguageStr('error_code4', '手机号或邮箱不能为空'),
		ACCOUNT_ALREADY_REGISTED: getLanguageStr('phrase15', '该账号已经存在'),
		USER_ALREADY_IN_ORGANIZATION: window.stage.loc.loginSystem.um
			? getLanguageStr('phrase791', '公司内已存在相同UM账号')
			: getLanguageStr('error_code15', '公司内已存在相同手机号/邮箱'),
		USER_NOT_EXIST_IN_ORGANIZATION: getLanguageStr('error_code16', '组织下不存在该用户'),
		SUPER_ADMIN_NOT_ALLOW_DELETE: getLanguageStr('error_code18', '超管不允许删除'),
		GROUP_MOVE_NOT_ALLOWED: getLanguageStr('error_code19', '不能把一个组移动到它本身或者它的下级组'),

		// 'ORG_NAME_DUPLICATE':'公司名称重复',
		ORG_NAME_DUPLICATE: getLanguageStr('phrase694', '商家名称已存在'),
		ACCOUNT_NOT_EXIST: '账号不存在', // getLanguageStr('phrase724', '账号不存在')
		ACCOUNT_ALREADY_BINDED: '绑定已存在', // getLanguageStr('phrase704','用户名已存在')
		ACC_ORG_AREA_NOT_MATCH_CURRENT_CENTER: getLanguageStr('create_business_area_tips', '因政策法规限制，当前应用暂不支持在该区域创建商家！'),

		// 权限
		'401': getLanguageStr('phrase639', '你的账号发生了变化，你需要重新登录，具体信息可联系本商家超级管理员。'),
		COMPANY_ID_IS_NULL: getLanguageStr('error_code7', '参数不合法'), // 公司ID未输入
		ROLE_NAME_IS_EXIST: i18n.t('plant_detail73', [getLanguageStr('word1695', '角色名称'), '已存在']),
		ROLE_IS_NOT_EXIST: i18n.t('fill3rd149', [getLanguageStr('word90', '角色'), '不存在']),
		ADMIN_DEFAULT_NOT_ALLOW_UPDATE: getLanguageStr('error_code20', '超管角色/默认角色不允许修改'),
		ADMIN_ROLE_NOT_ALLOW_DELETE: getLanguageStr('error_code21', '预设角色不允许删除'),
		PRESET_ROLE_NOT_ALLOW_DELETE: getLanguageStr('error_code21', '预设角色不允许删除'),
		ROLE_HAD_USER_NOT_ALLOW_DELETE: getLanguageStr('error_code22', '角色下有用户，不允许删除'),
		USER_HAD_IN_ROLE: getLanguageStr('error_code23', '用户已经在其他角色下'),
		USER_NOT_IN_ANY_ROLE: getLanguageStr('error_code24', '用户不在任何角色下'),
		ROLE_EXIST_IN_COMPANY: getLanguageStr('error_code25', '角色已经创建过了'),
		ACTION_NOT_EXIST: getLanguageStr('error_code7', '参数不合法'), // 请传入正确ACTION
		ROLE_PERMISSION_HAD_EXIST: i18n.t('plant_detail73', [getLanguageStr('manage366', '角色权限'), '已存在']),
		ROLE_PERMISSION_NOT_EXIST: i18n.t('fill3rd149', [getLanguageStr('manage366', '角色权限'), '不存在']),
		ROLE_TYPE_NOT_EXIST: i18n.t('fill3rd149', [getLanguageStr('manage377', '角色类型'), '不存在']),
		FUCNTION_CODE_HAD_EXIST: getLanguageStr('error_code26', '职能结构已经存在'),
		PERMISSION_TYPE_ERROR: getLanguageStr('error_code44', '权限类型错误'),
		ROLE_NUMBER_OVER_MAX: getLanguageStr('phrase857', '自定义角色数量已超过上限，上限为20'),
		OUT_ROLE_NUMBER_OVER_MAX: getLanguageStr('phrase856', '自定义外部角色数量已超过上限，上限为20'),
		LINK_PERMISSION_NOT_EXIST: getLanguageStr('error_code27', '关联权限不存在'),
		AU_NO_READ_PERMISSION: getLanguageStr('phrase781', '该电站没有权限查看'),
		AU_NO_OPERATION_PERMISSION: getLanguageStr('phrase783', '你没有权限，请联系本商家超级管理员开启'),
		AU_INVALID_ANNOTATION: getLanguageStr('error_code7', '参数不合法'),
		AU_PERMISSION_CHECK_PARAM_ERROR: getLanguageStr('error_code7', '参数不合法'), // 权限验证出错
		DUPLICATION_DATA_SOURCES: getLanguageStr('error_code28', '重复数据源'),
		ALERT_SPECIAL_RULE_ALREADY_EXISTS: getLanguageStr('phrase974', '该报警已存在特殊规则'),
		ALERT_SPECIAL_RULE_NUM_OVERFLOW: getLanguageStr('phrase966', '每个商家最多10个特殊规则'),

		// 电站
		STATION_AREA_NOT_MATCH_CURRENT_CENTER: getLanguageStr('create_plant_area_tips', '因政策法规限制，当前应用暂不支持在该区域建站！'),
		// 上传文件
		EXCEL_CONTENT_FORMAT_INCORRECT: getLanguageStr('error_code73', '导入文件格式不正确，请下载导入文件模版再导入'),
		OR_FILE_TYPE_ERROR: getLanguageStr('phrase31', '上传文件格式不正确'),
		OR_FILE_EMPTY_ERROR: getLanguageStr('error_code36', '文件空'),

		// 运维
		resource_not_exist_or_deleted: getLanguageStr('error_code90', '报警不存在'),
		ELECTRIC_MONTH_EXIST: getLanguageStr('bill37', '该电站在当月已有电费记录，请勿重复提交！'),
		VALUE_OFFSET_HAS_EXISTS: getLanguageStr('plant_detail197', '你输入的偏移量和当前日期已输入的偏移量重复，请输入一个不同的参数。'),

		// 项目中心
		MULTIPLE_NAME: getLanguageStr('assess7', '名称重复'),
		NOT_EXIST: getLanguageStr('error_code29', '对象不存在'),
		EXIST_WAIT_PAY: '该项目仍有待投放节点未处理',
		NOT_FINISH: '项目还未完成',
		STOP_ERROR: '只能中止准备中或建设中的项目',
		RESTART_ERROR: '只能重启中止的项目',
		UN_REJECT: '当前计划历史非未审核通过的',
		PLAN_EXIST: '已经存在执行计划',
		PLAN_CHANGED: '计划已经被修改，请在最新的版本上提交',
		PROCESS_CHANGED: '已经有新的进度被提交，请在最新的版本上提交',
		NO_SUPPORT: '格式不支持',
		APPROVER_DELETE: '当前项目没有审批人，请到项目基本信息中设置',
		APPROVE_NOT_EXIST: '有新的审批计划被提交或项目被删除,请重新操作',
		PROJECT_END: '项目已经结束',
		PROJECT_STOP: '项目已经中止',
		'resource_not_exist_or_deleted': getLanguageStr('error_code90', '报警不存在'),

		// 设备模块
		FIRMWARE_NAME_EXIST: i18n.t('plant_detail73', [getLanguageStr('word1778', '固件名称'), '已存在']),
		CODE_GROUP_EXIST: getLanguageStr('error_code30', '产品集已经配置'),
		COMPANY_CONFIG_EXIST: getLanguageStr('error_code31', '公司下产品集已经配置'),
		ORDER_RESPONSE_DATA_LEN_ERROR: getLanguageStr('error_code32', '指令响应值长度错误'),
		ORDER_RESPONSE_DATA_VERIFY_ERROR: getLanguageStr('error_code33', '指令响应值校验错误'),
		FILE_NOT_EXIST_ERROR: i18n.t('fill3rd149', [getLanguageStr('app104', '文件'), '不存在']),
		FILE_CRC32_ERROR: getLanguageStr('error_code34', '文件计算CRC32异常'),
		OR_ILLEGAL_OPERATION_ERROR: getLanguageStr('error_code7', '参数不合法'), // 非法操作
		OR_SYSTEM_ERROR: getLanguageStr('task69', '系统错误'),
		OR_PARAM_ERROR: getLanguageStr('error_code7', '参数不合法'), // 参数不一致
		OR_FIRMWARE_VERSION_ERROR: getLanguageStr('phrase865', '采集器固件版本升级规则未录入或重复录入'),
		OR_FILE_EMPTY_ERROR: getLanguageStr('error_code36', '文件空'),
		OR_FILE_UPLOAD_ERROR: getLanguageStr('上传错误', '上传错误'),
		OR_FILE_TYPE_ERROR: getLanguageStr('all3', '文件类型错误'),
		OR_FIRMWARE_OVER_MAX_SIZE_ERROR: getLanguageStr('error_code37', '固件太大'),
		OR_FILE_OVER_MAX_SIZE_ERROR: getLanguageStr('error_code38', '文件太大'),
		OR_FILE_CONVERT_SINENG_ERROR: getLanguageStr('error_code39', '固件包解密错误'),
		OR_FILE_EXIST_ERROR: i18n.t('plant_detail73', [getLanguageStr('app104', '文件'), '已存在']),
		OR_CALL_THRIFT_ERROR: getLanguageStr('error_code7', '参数不合法'), // thrift接口调用失败
		OR_GET_GATEWAY_VERSION_ERROR: getLanguageStr('error_code40', '获取采集器版本错误,无法升级'),
		OR_DEVICE_ADDRESS_NOT_EXIST_ERROR: getLanguageStr('error_code41', '从机地址不存在'),
		OR_CONTROL_OR_UPGRADE_NOT_SUPPORT_ERROR: getLanguageStr('error_code42', '该产品未开通控制或升级功能'),
		PARAM_ERROR_NO_INPUT_VALUE: getLanguageStr('error_code7', '参数不合法'), // 入参不能为空
		argument_validation_failed: getLanguageStr('device236', '参数错误'),
		COLLECTOR_FORBIDDEN_MOVE: getLanguageStr('phrase768', '采集器不允许编辑所属子系统'),
		DEVICE_HAS_EXISTED: getLanguageStr('phrase736', '该设备已加入到当前电站，不要重复添加'),
		GATEWAY_CAN_NOT_BE_AUTO_DISCOVERY: getLanguageStr('phrase741', '该网关/采集器不能进行自动添加子设备'),
		DEVICE_SN_CODE_CAN_NOT_EMPTY: getLanguageStr('error_code5', '设备sn不能为空'),
		DEVICE_EXISTED: getLanguageStr('phrase786', '部分子设备已被添加，请刷新列表'),
		NO_SYSTEM: getLanguageStr('phrase825', '暂未加入任何系统'),
		NO_DEVICE_EXISTS: getLanguageStr('error_code88', 'SN不存在'),
		NO_STATION_EXISTS: getLanguageStr('phrase825', '暂未加入任何系统'),
		EMPTY_FILE: getLanguageStr('phrase826', '文件为空'),
		UPLOAD_FILE_ERROR: getLanguageStr('phrase827', '文件格式不符'),
		'Parameter Error': getLanguageStr('phrase742', '服务器开了个小差，请稍后重试'),
		FILE_TYPE_ERROR: getLanguageStr('phrase31', '上传文件格式不正确'),
		OR_UPDATE_CODE_NULL: getLanguageStr('phrase875', '相应采集器的固件版本对应的升级指令格式没有录入'),
		OR_FILE_CONVERT_GROWATT_ERROR: getLanguageStr('error_code46', 'Growatt固件包转换错误'),
		OR_FILE_CONVERT_TYPE_ERROR: getLanguageStr('error_code47', '非法转换方式'),
		OR_FILE_RENAME_ERROR: getLanguageStr('error_code48', '文件删除失败'),
		OR_CUSTOM_ORDER_IS_NULL: getLanguageStr('error_code49', '自定义指令不能为空'),
		OR_NOT_SUPPORT: getLanguageStr('error_code50', '暂未开通该功能'),
		OR_WRITE_GPRS1_CONFIG_FILE_ERROR: getLanguageStr('error_code51', '写GPRS1升级配置文件错误'),
		OR_TRANSFER_DATA_NOT_SUPPORT_UPGRADE: getLanguageStr('error_code52', '迁移数据,使用非solarman超管账号重新上传固件包执行升级(或删除solarman公司下固件,重新上传)'),
		FIRMWARE_PATH_IS_NULL: getLanguageStr('error_code53', 'Growatt采集器固件需要设置文件路径'),
		OR_PARAM_PAGEINDEX_MIN_ERROR: getLanguageStr('error_code54', '分页参数错误'),
		OR_PARAM_PAGESIZE_OVER_MAX_ERROR: getLanguageStr('error_code55', '大小错误'),
		OR_OPERATION_TYPE_ERROR: getLanguageStr('error_code56', '操作类型错误'),
		OR_FIRMWARE_VERSION_ERROR: getLanguageStr('error_code57', '无法获取采集器固件版本对应的升级指令,原因:采集器固件版本升级规则未录入'),
		OR_THERE_ARE_ORDER_BEING_SENT: getLanguageStr('phrase893', '该设备有正在执行的执行，请稍后再试'),
		OR_CHECK_FIRMWARE_PACKAGE_SYNC_ERROR: getLanguageStr('error_code70', '系统错误,校验固件包是否同步出错'),
		OR_FIRMWARE_PACKAGE_HAVE_NOT_SYNC: getLanguageStr('error_code71', '正在获取固件包,请稍后重试'),
		OR_FILE_NAME_OVER_MAX_LENGTH_ERROR: getLanguageStr('OR_FILE_NAME_OVER_MAX_LENGTH_ERROR', '文件名称超过最大长度'),
		OR_FILE_NAME_ILLEGAL_CHARACTER_ERROR: getLanguageStr('OR_FILE_NAME_ILLEGAL_CHARACTER_ERROR', '文件名称有非法字符'),
		OR_CONFIG_NOT_SUPPORT_UPGRADE: getLanguageStr('OR_CONFIG_NOT_SUPPORT_UPGRADE', '升级方式为不支持升级'),
		// 配置信息维护
		MA_ILLEGAL_OPERATION_ERROR: getLanguageStr('error_code59', '非法操作'),
		MA_SYNC_DATA_NOT_ALLOW_UPDATE: getLanguageStr('manage140', 'API录入，不可编辑'),
		MA_SYNC_DATA_NOT_ALLOW_DELETE: getLanguageStr('manage141', 'API录入，不可删除'),
		MA_SYSTEM_ERROR: getLanguageStr('task69', '系统错误'),
		MA_PARAM_ERROR: getLanguageStr('device236', '参数错误'),
		MA_PARAM_PAGEINDEX_MIN_ERROR: getLanguageStr('error_code60', '分页index错误'),
		MA_PARAM_PAGESIZE_OVER_MAX_ERROR: getLanguageStr('error_code61', '单页条数超过上限'),
		MA_FILE_EMPTY_ERROR: getLanguageStr('error_code36', '文件空'),
		MA_FILE_UPLOAD_ERROR: getLanguageStr('error_code62', '上传错误'),
		MA_FILE_TYPE_ERROR: getLanguageStr('all3', '文件类型错误'),
		MA_FILE_OVER_MAX_SIZE_ERROR: getLanguageStr('error_code38', '文件太大'),
		MA_CONFIG_INFO_NOT_ALLOW_INSERT: getLanguageStr('error_code63', '公司没有采集器类型产品，不允许录入'),
		MA_EXCEL_NO_DATA: getLanguageStr('error_code64', 'excel没有数据或格式错误'),
		MA_EXCEL_SN_NOT_ALLOW_NULL: getLanguageStr('error_code65', 'SN不允许为空'),
		MA_EXCEL_FILED_OVER_MAX_SIZE: getLanguageStr('error_code66', 'SN或密码长度不能超过50'),
		// 运维
		OPEN_WEATHER_API_ERROR: getLanguageStr('phrase742', '服务器开了个小差，请稍后重试'),
		OR_AIR_MAX_SIZE_ERROR: getLanguageStr('文件最大数量为100', '文件最大数量为100'),
		'Server Failure': getLanguageStr('phrase742', '服务器开了个小差，请稍后重试'),
		GATEWAY_EXISTED: getLanguageStr('phrase874', '该设备已加入当前电站，不要重复添加'),
		AUTO_DISCOVERY_GATEWAY_EXISTED: getLanguageStr('phrase665', '该设备已加入到别的电站，无法添加'),
		VALUE_OFFSET_HAS_EXISTS: getLanguageStr('phrase894', '你输入的偏移量和当前日期已输入的偏移量重复，请输入一个不同的参数。'),

		// 标签
		TAG_NAME_DUPLICATE: getLanguageStr('manage353', '标签名称重复'),
		TAG_COUNT_EXCEED: i18n.t('fill3rd130', [getLanguageStr('word1471', '标签'), 50, '标签数量已超出上限，上限n个']),

		// 个人设置
		OLD_PASSWORD_WRONG: getLanguageStr('phrase726', '原密码不正确'),
		USERNAME_FORMAT_ERROR: getLanguageStr('error_code45', '用户名格式不正确'),
		EMAIL_FORMAT_ERROR: getLanguageStr('phrase18', '邮箱格式不正确'),

		ADD_ENTITY_REL_TO_SELF_NOT_ALLOWED: getLanguageStr('phrase747', '不允许添加自己'),

		// 外部关联电站
		AU_NO_OUT_OPERATION_PERMISSION: getLanguageStr('phrase783', '你没有权限，请联系本商家超级管理员开启'), // 没有编辑权限

		// 报表
		NO_DATA_FOR_NOW: getLanguageStr('phrase390', '当前没有数据诶'),
		// 429:请求太频繁
		REQUEST_TOO_FREQUENTLY: getLanguageStr('error_code122', '操作过于频繁，请稍后再试'),

		// 组件
		FILE_TYPE_NOT_SUPPORTED: getLanguageStr('phrase31', '上传文件格式不正确'),
		SN_MAX_LIMIT: getLanguageStr('error_code72', '导入文件中的SN超过4000的上限，请减少SN的数量'),
		CONTENT_FORMAT_INCORRECT: getLanguageStr('error_code73', '导入文件格式不正确，请下载导入文件模版再导入'),
		X_Y_CANNOT_NULL: getLanguageStr('error_code74', '已找到符合的组件SN，但是缺少坐标信息，请检查导入文件'),
		X_Y_REPEAT: getLanguageStr('error_code76', '已找到符合的组件SN，但是存在重复的坐标或组串信息，请检查导入文件'),
		GROUP_INDEX_OR_GROUP_NUMBER_IS_NULL: getLanguageStr('error_code75', '已找到符合的组件SN，但是组串信息不完整，请检查导入文件'),
		GROUP_INDEX_GROUP_NUMBER_REPEAT: getLanguageStr('error_code76', '已找到符合的组件SN，但是存在重复的坐标或组串信息，请检查导入文件'),
		LAYOUT_CANNOT_INTEGER: getLanguageStr('error_code77', '组件布局信息必须为正整数，不允许为0或负数'),
		SN_REPEAT: getLanguageStr('error_code78', '已找到符合的组件SN，但是存在重复的SN号，请检查导入文件'),
		SN_INVALID: getLanguageStr('error_code79', '未识别到符合的组件SN，请检查导入文件'),
		GROUP_INDEX_GROUP_NUMBER_NOT_CONTINUOUS: getLanguageStr('error_code81', '组串和编号信息必须连续且从1开始，比如1、2、3'),

		// 批量任务
		DEVICE_INACTIVATED_CONTROLLER: getLanguageStr('phrase936', '设备暂未激活，无法进行设备控制'),
		NO_TASK_EXISTS: getLanguageStr('task76', '任务不存在'),
		TASK_IS_NOT_PENDING_RELEASE: getLanguageStr('task75', '非待发布任务'),
		// 'NO_DEVICE_EXISTS': getLanguageStr('phrase24','设备不存在'),
		DEVICE_INACTIVATED_UPDATE: getLanguageStr('phrase935', '设备暂未激活，无法进行固件升级'),
		'NOT_MORE_THAN_200': getLanguageStr('task74', 'excel SN数量不能大于200'),
		MSG_UPGRADE_NOT_SUPPORT: getLanguageStr('error_code85', '自定义指令长度超过限制'),
		OR_CUSTOM_ORDER_LENGTH_OVER_MAX: getLanguageStr('error_code86', '不支持短信升级'),
		SN_ALREADY_EXISTS: getLanguageStr('phrase981', 'SN已存在'),
		DEVICE_TYPE_NOT_MATCH: getLanguageStr('error_code89', '设备类型不符'),
		START_TOO_EARLY: getLanguageStr('task86', '任务开始时间不得早于当前时间'),
		FIRMWARE_VERSION_EXIST: getLanguageStr('error_code96', '固件包已存在'),
		NETWORK_DEVICE_INACTIVATED: getLanguageStr('error_code97', '组网-该设备未激活，无法组网，请确认上电并成功连接服务器后重试'),
		NETWORK_NOT_SUPPORT: getLanguageStr('Networking8', '该设备不支持或不需要组网'),
		MA_SN_NOT_EXIST: getLanguageStr('error_code88', 'SN不存在'),
		MA_EXCEL_TOO_MANY_DATA: getLanguageStr('error_code95', 'excel行数超出限制'),
		MA_EXCEL_MICROINVERTER_NOT_ALLOW_NULL: getLanguageStr('error_code93', '微逆SN号不可为空'),
		MA_EXCEL_SN_NOT_ALLOW_FORMAT: getLanguageStr('error_code95', 'excel行数超出限制'),
		MA_EXCEL_MICROINVERTER_REPEAT: getLanguageStr('error_code98', '存在重复SN'),

		// 大屏设置
		BIG_SCREEN_CONFIG_NAME_LEN_EXCEED: getLanguageStr('fullscreen2', '大屏标题字数超限'),
		OR_PRODUCT_NOT_BELONG_TO_COMPANY: getLanguageStr('error_code99', '产品不属于该公司'),
		OR_SOLARMAN_NOT_ALLOWED_TRANSFER: getLanguageStr('error_code100', 'Solarman采集器不允许转让'),

		// Iv
		OR_IV_DEVICE_IS_SCANNING: getLanguageStr('error_code102', 'IV曲线正在扫描中,请稍后再执行'),
		OR_TEMPLATE_NOT_EXIST: getLanguageStr('error_code103', '模板不存在'),
		OR_DATA_FORMAT_ERROR: getLanguageStr('error_code104', '数据格式错误'),
		access_denied: getLanguageStr('error_code8', '你没有权限')
	};
}, 50);

export default function translate (messageId) {
	return message[messageId] || message['sorry_for_server_exception'];
}



// WEBPACK FOOTER //
// ./src/util/errorCode.js